import React, { useMemo, useRef } from 'react';
import { Typography, Box } from '@mui/material';

import styles from './TideHeightTooltip.module.scss';

interface Props {
  tideHeight: number;
  units: string | undefined;
  leftPosition: number;
  graphWidth: number;
}

const TideHeightTooltip: React.FC<Props> = ({ tideHeight, units, leftPosition, graphWidth }) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const positionStyles = useMemo(() => {
    const tooltipWidth = tooltipRef?.current?.offsetWidth ?? 0;
    let leftVal = leftPosition;
    if (leftPosition > 25) leftVal = leftPosition - tooltipWidth / 2;
    if (graphWidth - leftPosition < 25) leftVal = leftPosition - tooltipWidth;
    return {
      left: `${leftVal}px`,
    };
  }, [graphWidth, leftPosition]);

  return (
    <Box
      className={styles.container}
      data-testid="tide-height-reading-tooltip-container"
      ref={tooltipRef}
      style={positionStyles}
    >
      <Typography
        variant="callout1"
        component="span"
        data-testid="tide-height-reading-tooltip-value"
      >
        {tideHeight?.toFixed(1)}
      </Typography>
      {units && (
        <Typography
          variant="callout2"
          component="span"
          className={styles.unit}
          data-testid="tide-height-reading-tooltip-units"
        >
          {units}
        </Typography>
      )}
    </Box>
  );
};

export default TideHeightTooltip;
